// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"3f26ac00","311":"924a69aa","856":"7a1d883c"}[chunkId] + ".chunk.js";
};